<template>
  <div id="mapContainer" style="height: 70vh !important"></div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gpx/gpx.js";
import "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import * as turf from "@turf/turf";
import { parse } from "qs";
export default {
  components: {},
  props: ["coureurs", "lines", "parcours", "focus_point", "selected_mode"],
  data() {
    return {
      map: {},
      list_marker_points: [],
      marker_coureur: {},
      focus_marker: {},
      line: [],
      icons: [],
      fond_carte: {},
    };
  },
  watch: {
    selected_mode: function (newVal, oldVal) {
      this.fond_carte.setUrl(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link);
    },
    focus_point: function (newVal, oldVal) {
      // watch it
      if (Object.keys(this.focus_marker).length === 0) {
        var options = {
          units: "kilometers",
        };
        var point_coordinates = turf.along(this.line, this.focus_point, options);

        this.focus_marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: "focus",
          icon: this.icons["focus"],
        });
        this.focus_marker.addTo(this.map);
      } else {
        if (this.focus_point === 0) {
          this.map.removeLayer(this.focus_marker);
          this.focus_marker = {};
        } else {
          var point_coordinates = turf.along(this.line, this.focus_point, options);
          this.focus_marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        }
      }
    },
    coureurs: function (newVal, oldVal) {
      // watch it
      for (var i = 0; i < oldVal.length; i++) {
        if (oldVal[i].marker) {
          this.map.removeLayer(oldVal[i].marker);
        }
      }
      if (newVal.length > 0) {
        this.displayPoints();
        this.defineMarkers();
        this.displayCoureurs();
      }
    },
    lines: function (newVal, oldVal) {
      this.line = turf.lineString(newVal);
      this.displayPoints();
    },
    parcours: function (newVal, oldVal) {
      var _this = this;
      if (this.gpx) {
        this.map.removeLayer(this.gpx);
      }
      this.gpx = new L.GPX(newVal.trace, {
        polyline_options: {
          color: "#8d0801",
          opacity: 0.9,
          weight: 4,
          lineCap: "round",
        },
        async: true,
        marker_options: {
          wptIconUrls: {
            "": "https://sportips.fr/live/includes/img/wp.png",
          },
          startIconUrl: "https://sportips.fr/live/includes/img/pin-start.png",
          endIconUrl: "https://sportips.fr/live/includes/img/pin-end.png",
        },
      })
        .on("loaded", function (e) {
          _this.map.fitBounds(e.target.getBounds());
        })
        .addTo(this.map);

      if (newVal.centre_trace.length > 0) {
        this.map.setView(newVal.centre_trace, 13);
      }
      this.displayPoints();
    },
  },

  methods: {
    defineMarkers: function () {
      var options = {
        units: "kilometers",
      };
      var point_coordinates = turf.along(this.line, 0, options);
      for (var i = 0; i < this.coureurs.length; i++) {
        this.coureurs[i].marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: this.coureurs[i].dossard,
          icon: L.divIcon({
            className: "coureur-icon",
            html:
              "<div class='pin_runner_profil_container_map'><img class='pin_runner_profil_map' src='https://sportips.fr/live/includes/img/pin-runner-2.png'/><span class='pin_runner_content_map'>" +
              this.coureurs[i].nom.charAt(0).toUpperCase() +
              this.coureurs[i].prenom.charAt(0).toUpperCase() +
              "</span></div>",
            iconAnchor: [17, 40],
          }),
        });
        this.coureurs[i].marker.addTo(this.map);
      }
    },
    displayCoureurs: function () {
      var options = {
        units: "kilometers",
      };
      for (var i = 0; i < this.coureurs.length; i++) {
        var point_coordinates;
        if (!this.coureurs[i].parcours.start) {
          point_coordinates = turf.along(this.line, 0, options);
          this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        } else if (this.coureurs[i].parcours.end) {
          point_coordinates = turf.along(this.line, parseFloat(this.coureurs[i].parcours.nb_km), options);
          this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        } else {
          if (this.coureurs[i].tracking_methode === "estimation") {
            if (this.coureurs[i].estimation.distance) {
              if (this.coureurs[i].estimation.distance < 0) {
                this.coureurs[i].estimation.distance = 0;
              }
              point_coordinates = turf.along(this.line, parseFloat(this.coureurs[i].estimation.distance), options);
              this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
            }
          } else {
            this.coureurs[i].marker.setLatLng([this.coureurs[i].position[0], this.coureurs[i].position[1]]);
          }
        }
      }
    },
    displayPoints: function () {
      for (var i = 0; i < this.list_marker_points.length; i++) {
        this.map.removeLayer(this.list_marker_points[i]);
      }
      this.list_marker_points = [];
      var options = {
        units: "kilometers",
      };
      if (!this.parcours.points) {
        return;
      }
      for (let j = 0; j < this.parcours.points.length; j++) {
        let current_point = this.parcours.points[j];
        if (!this.parcours.line) {
          break;
        }
        let point_coordinates = turf.along(this.line, parseFloat(current_point.distance_depuis_depart), options);
        var marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: current_point.nom_affiche + current_point.parcours_id,
          icon: this.icons["point"],
        });
        this.list_marker_points.push(marker);
        marker.addTo(this.map);
      }
    },

    initMap() {
      var _this = this;
      this.map = L.map("mapContainer", {
        zoomControl: false,
      });
      if (this.parcours.centre_trace.length > 0) {
        this.map.setView(this.parcours.centre_trace, 13);
      }
      this.fond_carte = L.tileLayer(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link, {
        zoomControl: false,
        maxZoom: 17,
        attribution:
          'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
      }).addTo(this.map);

      this.gpx = new L.GPX(this.parcours.trace, {
        polyline_options: {
          color: "#8d0801",
          opacity: 0.9,
          weight: 4,
          lineCap: "round",
        },
        async: true,
        marker_options: {
          wptIconUrls: {
            "": "https://sportips.fr/live/includes/img/wp.png",
          },
          startIconUrl: "https://sportips.fr/live/includes/img/pin-start.png",
          endIconUrl: "https://sportips.fr/live/includes/img/pin-end.png",
        },
      })
        .on("loaded", function (e) {
          _this.map.fitBounds(e.target.getBounds());
        })
        .addTo(this.map);
    },
    setIcons: function () {
      /* this.icons["coureur"] = L.icon({
                iconUrl: 'https://sportips.fr/live/includes/img/pin-runner.png',
                iconSize: [24, 37],
                iconAnchor: [12, 37],
            }); */
      this.icons["coureur"] = L.divIcon({
        className: "custom-div-icon",
        html: "<div style='background-color:#c30b82;' class='marker-pin'></div><i class='material-icons'>weekend</i>",
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      });
      this.icons["focus"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/focus_point.png",
        iconSize: [15, 15],
        iconAnchor: [7, 7],
      });
      this.icons["point"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/pin-checkpoint-before.png",
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      });
    },
  },
  mounted() {
    this.setIcons();
    this.initMap();
    this.line = turf.lineString(this.lines);
    this.displayPoints();
    this.defineMarkers();
    this.displayCoureurs();
  },
};
</script>

<style>
#mapContainerLive {
  width: 100% !important;
  height: 80vh !important;
  min-height: 300px;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  box-shadow: rgb(33 35 38 / 10%) 0px 10px 10px -10px !important;
  border: 1px solid #dbe0e6 !important;
  border-bottom: none !important;
}

.custom-marker-pin {
  padding: 5px;
  border: 1px solid #f29200;
}
</style>
